// assets
import { IconBuildingFactory, } from '@tabler/icons';

// constant
const icons = {
    IconBuildingFactory,
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const industryPages = {
    id: 'Industry management',
    title: 'Industry management',
    caption: 'manage industry list',
    type: 'group',
    children: [
        {
            id: 'fetchIndustry',
            title: 'Industry',
            type: 'item',
            url: '/industries/View',
            icon:icons.IconBuildingFactory
        }
    ],

};

export default industryPages;
